import { Capacitor } from '@capacitor/core'

// App Review §3.1.1: the native app informs, it never sells (spec, rule 8).
export function purchasesAllowedOn(native: boolean): boolean {
  return !native
}

export function purchasesAllowed(): boolean {
  return purchasesAllowedOn(Capacitor.isNativePlatform())
}
